


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PnlReserveItems extends Vue {
@Prop({default:true}) public tab: boolean;    //タブモードでは全て出力
@Prop({default:null}) public editor: boolean;  
@Prop({default:true}) public enabled: boolean;
@Prop({default:false}) public inheritCommodityAttributeInvalid: boolean;    // Order継承時、商品属性の変更不可
@Prop({default:Common.visibleTypes.None}) public commodityAttribute: Common.visibleTypes;
@Prop({default:Common.visibleTypes.None}) public stockAttribute:Common.visibleTypes;
@Prop({default:Common.visibleTypes.None}) public orderMemo: Common.visibleTypes;
@Prop({default:Common.visibleTypes.None}) public deliveryMemo: Common.visibleTypes;
@Prop({default:Common.visibleTypes.None}) public commodityMemo: Common.visibleTypes;
@Prop() public commodity: Common.Commodity;


@Prop() public item: any; //バインド対象

    public tenantSettings: Common.TenantSettings = null;
    //予備項目名称は対応予定
    public created(){
        this.tenantSettings = this.$api.tenantSettings;
    }
    public isEditable(usedType: Common.UsedTypes){
        if (this.enabled && this.commodityAttribute == Common.visibleTypes.Editable && usedType == Common.UsedTypes.CommodityAttribute) {
            if (this.inheritCommodityAttributeInvalid && (this.item.salesOrderItemNo || this.item.orderItemId))
                return false;
            else
                return true;
        }
        if (this.enabled && this.stockAttribute == Common.visibleTypes.Editable && usedType == Common.UsedTypes.StockAttribute) return true;
        if (this.enabled && this.orderMemo == Common.visibleTypes.Editable && usedType == Common.UsedTypes.OrderMemo) return true;
        if (this.enabled && this.deliveryMemo == Common.visibleTypes.Editable && usedType == Common.UsedTypes.DeliveryMemo) return true;            
        if (this.enabled && this.commodityMemo == Common.visibleTypes.Editable && usedType == Common.UsedTypes.CommodityMemo) return true;            
        return false;
    }

    public isVisible(usedType: Common.UsedTypes){
        if (this.commodityAttribute != Common.visibleTypes.None && usedType == Common.UsedTypes.CommodityAttribute) return true;
        if (this.stockAttribute != Common.visibleTypes.None && usedType == Common.UsedTypes.StockAttribute) return true;
        if (this.orderMemo != Common.visibleTypes.None && usedType == Common.UsedTypes.OrderMemo) return true;
        if (this.deliveryMemo != Common.visibleTypes.None && usedType == Common.UsedTypes.DeliveryMemo) return true;            
        if (this.commodityMemo != Common.visibleTypes.None && usedType == Common.UsedTypes.CommodityMemo) return true;            
        return false;
    }
    public visiblePattern(usedType: Common.UsedTypes){
        if (this.isVisible(usedType)) return 1;  // 通常表示
        if (usedType == Common.UsedTypes.CommodityMemo && this.commodity) return 3;   // 商品メモ表示
        return 2;  // 設定表示
    }

    public caption(usedType: Common.UsedTypes){
        if (usedType == Common.UsedTypes.CommodityAttribute) return '(商品識別情報)';
        if (usedType == Common.UsedTypes.StockAttribute) return '(在庫識別情報)';
        if (usedType == Common.UsedTypes.OrderMemo) return '(受発注メモ)';
        if (usedType == Common.UsedTypes.DeliveryMemo) return '(入出荷メモ)';          
        if (usedType == Common.UsedTypes.CommodityMemo) return '(商品メモ)';          
        if (usedType == Common.UsedTypes.None) return '(未使用)';                  
        return '';              
    }
}
